import Class from './c-widget';
import './c-widget@';

export default Class;